var _defs, _rect, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeGooglePlayDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 239 70.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st1{isolation:isolate}.st5{fill:#fff}\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.1,
    width: 239.2,
    height: 70.9,
    rx: 8.9,
    ry: 8.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.6 38.5c-4.1 0-7.5 3.2-7.5 7.6s3.4 7.5 7.5 7.5 7.6-3.2 7.6-7.5-3.4-7.6-7.6-7.6Zm0 12.1c-2.3 0-4.2-1.8-4.2-4.5s2-4.6 4.2-4.6 4.3 1.9 4.3 4.6-2 4.5-4.3 4.5Zm-16.5-12c-4.2 0-7.6 3.1-7.6 7.5s3.4 7.5 7.6 7.5 7.6-3.2 7.6-7.5-3.4-7.6-7.6-7.6Zm0 12c-2.3 0-4.3-1.8-4.3-4.5s2-4.6 4.3-4.6 4.3 1.9 4.3 4.6-2 4.5-4.3 4.5Zm-19.6-9.8V44H92a6.6 6.6 0 0 1-1.7 4 7.8 7.8 0 0 1-6 2.4 8.4 8.4 0 0 1-8.3-8.5 8.4 8.4 0 0 1 14.1-6.2l2.3-2.3c-2-1.8-4.5-3.2-8-3.2-6.5 0-12 5.3-12 11.7s5.5 11.7 12 11.7c3.5 0 6-1 8.1-3.2 2.1-2.1 2.8-5.1 2.8-7.5 0-.8 0-1.5-.2-2H84.5Zm80.3 2.5c-.7-1.6-2.6-4.8-6.5-4.8s-7.1 3-7.1 7.6c0 4.2 3.2 7.5 7.5 7.5 3.4 0 5.4-2.1 6.3-3.3l-2.6-1.8c-.9 1.3-2 2.1-3.7 2.1s-3-.7-3.7-2.3l10.1-4.1-.3-.9ZM154.4 46a4 4 0 0 1 3.9-4.4c1.3 0 2.4.6 2.8 1.6l-6.7 2.8Zm-8.2 7.3h3.3V31h-3.3v22.1Zm-5.4-13h-.1a5.2 5.2 0 0 0-4-1.7c-3.8 0-7.3 3.3-7.3 7.6s3.5 7.5 7.3 7.5c1.8 0 3.2-.8 4-1.7v1c0 3-1.5 4.5-4 4.5-2 0-3.2-1.4-3.8-2.7l-2.8 1.2c.8 2 3 4.5 6.6 4.5 4 0 7.2-2.3 7.2-7.9V39h-3.1v1.2ZM137 50.6c-2.3 0-4.2-1.9-4.2-4.5s1.9-4.6 4.2-4.6 4 2 4 4.6-1.8 4.5-4 4.5ZM180.3 31h-8v22.1h3.4v-8.4h4.6c3.7 0 7.2-2.6 7.2-6.8S184 31 180.3 31Zm0 10.7h-4.7V34h4.7c2.5 0 4 2 4 3.8s-1.5 3.8-4 3.8Zm20.5-3.2c-2.4 0-4.9 1-6 3.4l3 1.2c.6-1.2 1.8-1.6 3-1.6 1.7 0 3.5 1 3.5 2.8v.3c-.6-.4-1.9-.9-3.5-.9-3.1 0-6.3 1.7-6.3 5 0 3 2.6 4.8 5.5 4.8 2.2 0 3.4-1 4.2-2.1V53h3.3v-8.5c0-4-3-6.1-6.7-6.1Zm-.4 12.1c-1.1 0-2.6-.5-2.6-1.8 0-1.7 1.9-2.4 3.5-2.4 1.4 0 2.1.3 3 .7a4 4 0 0 1-4 3.5ZM219 39l-3.8 9.6-4-9.6h-3.6l6 13.4-3.4 7.5h3.4l9.1-21H219Zm-29.7 14h3.4V31h-3.3v22.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m36.6 34.4-18.9 20a5 5 0 0 0 7.6 3l21.2-12.2-10-10.8h.1Z",
    style: {
      fill: "#ea4335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.7 31-9.2-5.3-10.3 9.2 10.3 10.3 9.2-5.2c1.5-1 2.6-2.6 2.6-4.5s-1-3.6-2.6-4.5Z",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.7 16.4-.1 1.4V53l.1 1.3L37.2 35 17.7 16.4Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.7 35.4 9.8-9.7-21.2-12.3a5.1 5.1 0 0 0-7.6 3l19 19Z",
    style: {
      fill: "#34a853"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74.4 22.8c-.6-.4-1-1-1.3-1.9l1.6-.6c.3 1 1 1.6 1.9 1.6.5 0 1-.2 1.3-.6s.5-.8.5-1.4v-7.7H80v7.6c0 .8-.2 1.4-.5 2s-.7 1-1.2 1.3-1.1.4-1.8.4c-.8 0-1.6-.2-2.2-.7Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M82.8 12.2h6.7V14h-5v3H89v1.7h-4.5v3h5v1.6h-6.7v-11Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M94.2 13.9H91v-1.7h8V14h-3.1v9.4H94V14Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m100.2 21.5 5.8-7.6h-5.5v-1.7h7.5V14l-5.7 7.6h5.7v1.7h-7.8v-1.8Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.6 13.9h-3.1v-1.7h7.9V14h-3.1v9.4h-1.7V14Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.6 12.2h4.2a3.4 3.4 0 0 1 2.8 1.5c.3.4.4 1 .4 1.5s-.1 1-.4 1.4c-.3.4-.6.7-1 .9.5.3 1 .6 1.3 1s.5 1 .5 1.6-.2 1.2-.5 1.6-.7.9-1.2 1.1c-.6.3-1.1.4-1.8.4h-4.3v-11Zm4 4.7c.6 0 1-.2 1.3-.5s.4-.7.4-1-.1-.8-.4-1.1-.7-.5-1.2-.5h-2.4v3h2.4Zm.3 4.8c.6 0 1-.2 1.3-.6s.5-.7.5-1-.2-.9-.5-1.2c-.3-.3-.8-.5-1.3-.5h-2.5v3.3h2.6Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M132.6 12.2h6.7V14h-5v3h4.5v1.7h-4.5v3h5v1.6h-6.7v-11Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.7 12.2h1.7v11h-1.7v-11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGooglePlayDe);
export default __webpack_public_path__ + "static/media/badge-google-play-de.5ad895d4c02a671f39b6ae9a4a3745ff.svg";
export { ForwardRef as ReactComponent };